export const getAuthenticationAPIURL = (uniquelink, uniquekey, dob) =>
    `auth/xp/member/${uniquelink}/module/${uniquekey}/dateofbirth/${dob}`;

export const getAuthenticationLegacyAPIURL = (uniquelink, dob) => `auth/member/${uniquelink}/dateofbirth/${dob}`;
export const getMemberCarePlanAPIURL = (uniquelink, uniquekey, language) =>
    `xp/member/${uniquelink}/module/${uniquekey}/language/${language}/careplan`;
export const getMemberCarePlanLegacyAPIURL = (uniquelink) => `members/${uniquelink}/careplan`;
export const getMemberInfoAPIURL = (referralid) => `xp/assessments/referrals/${referralid}/assessments`;
export const getAssessmentModuleAPIURL = (referralid, assessmentplanid) =>
    `xp/assessments/referrals/${referralid}/assessmentplans/${assessmentplanid}/assessmodules`;
export const getAssessmentQuestionsURL = (referralid) => `xp/assessments/referrals/${referralid}/questionaires`;
export const getSaveAssmtURL = () => 'xp/assessments/save';

export const saveCategoryIntervensionApiURL = (referralid) => {
    return `xp/assessments/referrals/${referralid}/interventionassessments`;
};
